import { TiArrowSortedDown } from 'react-icons/ti';
import {
  FaArrowDownLong,
  FaArrowRight,
  FaArrowRightFromBracket,
  FaArrowRightToBracket,
  FaArrowUpLong,
  FaCaretDown,
  FaCheck,
  FaUsers,
  FaInstagram,
} from 'react-icons/fa6';
import { BiSolidEdit } from 'react-icons/bi';
import { IoMdArrowRoundBack } from 'react-icons/io';
import { CgMenuLeft, CgProfile } from 'react-icons/cg';
import { IoCloseOutline, IoEyeOffOutline, IoEyeOutline } from 'react-icons/io5';
import {
  MdEdit,
  MdBlockFlipped,
  MdOutlineMarkEmailRead,
  MdOutlineSettings,
  MdOutlineVerifiedUser,
  MdContentCopy,
} from 'react-icons/md';
import { CiBank, CiLogin, CiSearch } from 'react-icons/ci';
import { MdOutlineAccountBalanceWallet } from 'react-icons/md';

import {
  FaExchangeAlt,
  FaChevronDown,
  FaTrashAlt,
  FaLinkedin,
  FaExclamation,
  FaTwitter,
  FaYoutube,
  FaRegArrowAltCircleRight,
  FaRegSave,
  FaMagic,
  FaPlus,
  FaMinus,
  FaArrowLeft,
} from 'react-icons/fa';
import { FiPlusCircle } from 'react-icons/fi';
import { RiErrorWarningFill } from 'react-icons/ri';
import {
  BsCheckLg,
  BsChevronLeft,
  BsChevronRight,
  BsFacebook,
  BsThreeDotsVertical,
} from 'react-icons/bs';
import { IoMdAdd, IoMdClose } from 'react-icons/io';
import { MdOutlineLock, MdOutlineLockOpen } from 'react-icons/md';
import { BsCurrencyRupee } from 'react-icons/bs';
import { FaRegCalendarMinus } from 'react-icons/fa6';
import { IoIosArrowRoundBack } from 'react-icons/io';
import { BiSolidDownArrow } from 'react-icons/bi';
import { GiTakeMyMoney } from 'react-icons/gi';
import { ImSpinner9 } from 'react-icons/im';
import { TbTargetArrow } from 'react-icons/tb';
import { LuCalendarClock } from 'react-icons/lu';

export const reactIcons = {
  shortDownArrow: <BiSolidDownArrow />,
  bonus: <GiTakeMyMoney />,
  arrowLeft: <IoIosArrowRoundBack />,
  wallet: <MdOutlineAccountBalanceWallet />,
  dollar: <BsCurrencyRupee />, // the app is in rupees (the key name is kept for its callers),
  calendar: <FaRegCalendarMinus />,
  profile: <CgProfile />,
  magic: <FaMagic />,
  delete: <FaTrashAlt />,
  left: <FaArrowLeft />,
  longBack: <IoMdArrowRoundBack />,
  youtube: <FaYoutube />,
  linkdin: <FaLinkedin />,
  twitter: <FaTwitter />,
  insta: <FaInstagram />,
  fb: <BsFacebook />,
  threedot: <BsThreeDotsVertical />,
  block: <MdBlockFlipped />,
  roundplus: <FiPlusCircle />,
  arrowleft: <BsChevronLeft />,
  arrowright: <BsChevronRight />,
  edit: <MdEdit />,
  arrowDown: <FaArrowDownLong />,
  exclamation: <FaExclamation />,
  arrowUp: <FaArrowUpLong />,
  arrowdown: <FaChevronDown />,
  exchange: <FaExchangeAlt />,
  closeIcon: <IoCloseOutline />,
  checkMark: <FaCheck />,
  eye: <IoEyeOutline />,
  eyesplash: <IoEyeOffOutline />,
  warning: <RiErrorWarningFill />,
  check: <BsCheckLg />,
  trash: <FaTrashAlt />,
  add: <IoMdAdd />,
  search: <CiSearch />,
  rightarrow: <FaRegArrowAltCircleRight />,
  rightemail: <MdOutlineMarkEmailRead />,
  close: <IoMdClose />,
  dropdown: <FaCaretDown />,
  settings: <MdOutlineSettings />,
  verifiaction: <MdOutlineVerifiedUser />,
  bank: <CiBank />,
  logout: <CiLogin />,
  save: <FaRegSave />,
  arrowL: <FaArrowRight />,
  bucketright: <FaArrowRightFromBracket />,
  bucketleft: <FaArrowRightToBracket />,
  copy: <MdContentCopy />,
  menu: <CgMenuLeft />,
  lock: <MdOutlineLock />,
  unlock: <MdOutlineLockOpen />,
  shortdown: <TiArrowSortedDown />,
  users: <FaUsers />,
  edit2: <BiSolidEdit />,
  spinLoader: <ImSpinner9 />,
  target: <TbTargetArrow />,
  calender: <LuCalendarClock />,
  plus: <FaPlus />,
  minus: <FaMinus />,
};
